import { Link, Text } from '@nimbus-ds/components';
import { AlertSessionStorage } from 'App/components';
import { useNavegate } from 'App/hooks';
import { useTranslationsMetafields } from 'domains/Metafields/hooks';
import useGetProductsAndVariantsMetafields from 'domains/Metafields/hooks/ProductsAndVariants/useGetProductsAndVariantsMetafields';

export default function AlertCreateProductsAndVariantsMetafields(): JSX.Element | null {
  const { hasInternals, hasExternals, status, isAvailable } =
    useGetProductsAndVariantsMetafields();
  const t = useTranslationsMetafields();
  const { goTo } = useNavegate();

  const handleClick = () => {
    goTo('/settings/metafields');
  };

  if (!status.isSuccess || !isAvailable || hasInternals || hasExternals)
    return null;

  return (
    <AlertSessionStorage
      keyName="alertCreateProductsAndVariantsMetafields"
      appearance="primary"
      title={t('alertCreateProductsAndVariantsMetafields.title')}
    >
      <Text color="neutral-textDisabled">
        {t('alertCreateProductsAndVariantsMetafields.description')}
      </Text>
      <Link onClick={handleClick}>
        {t(`alertCreateProductsAndVariantsMetafields.link`)}
      </Link>
    </AlertSessionStorage>
  );
}
